import { render, staticRenderFns } from "./BConversion.vue?vue&type=template&id=4dd6a2a0&scoped=true"
import script from "./BConversion.vue?vue&type=script&lang=js"
export * from "./BConversion.vue?vue&type=script&lang=js"
import style0 from "./BConversion.vue?vue&type=style&index=0&id=4dd6a2a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd6a2a0",
  null
  
)

export default component.exports